module.exports = __webpack_public_path__ + "static/img/mall_tab_icon_6_2.c17e267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_tab_icon_6_2.png
// module id = xAt7
// module chunks = 0